__turbopack_context__.v({
  "activeCodesDescription": "vqzxoq_activeCodesDescription",
  "activeCodesList": "vqzxoq_activeCodesList",
  "activeCodesListItem": "vqzxoq_activeCodesListItem",
  "activeCodesWrapper": "vqzxoq_activeCodesWrapper",
  "hr": "vqzxoq_hr",
});
